<template>
    <div v-if="showSubscribeToNotification" class="fixed top-0 left-0 w-full h-full backdrop-brightness-75 backdrop-blur-md z-50">
        <div class="inline-flex flex-col gap-3 bg-white p-4 rounded-md m-4 max-w-[350px]">
            <img class="h-6" style="width: fit-content" :src="$asset('/hkcm/images/logo-on-light-background.svg', 'public')" alt="HKCM Logo" title="HKCM Logo" />
            <strong>
                {{ $t('live_updates_headline') }}
            </strong>
            <p>
                {{ $t('live_updates_headline_description') }}
            </p>
            <div class="flex flex-row gap-2 justify-end">
                <button class="btn primary w-auto sm" @click="enableNotifications">
                    {{ $t('plain_apply') }}
                </button>
                <button class="btn white w-auto sm" @click="close">
                    {{ $t('plain_decline') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data: () => ({
        beamsGranted: false,
        beamsRegistrationState: null,
        showSubscribeToNotification: false
    }),

    methods: {
        close() {
            this.$cookies.set('webnotifications_declined', true, 60 * 60 * 24 * 30); // set cookie for 30 days
            this.showSubscribeToNotification = false;
        },

        async enableNotifications() {
            if ('Notification' in window && 'PushManager' in window && window.location.protocol === 'https:') {
                this.showSubscribeToNotification = false;

                this.$beams
                    .start()
                    .then(() => this.$beams.setUserId(this.user?.id, this.$beamsTokenProvider))
                    .then(() => console.log('User ID has been set'))
                    .catch((error) => console.error('Could not authenticate with Beams:', error));
            }
        },

        handleChange() {
            if ('Notification' in window && 'PushManager' in window && window.location.protocol === 'https:') {
                if (this.beamsGranted) {
                    this.showSubscribeToNotification = false;
                } else if (this.isLoggedIn && this.beamsRegistrationState && this.$cookies.get('webnotifications_declined') === null) {
                    this.showSubscribeToNotification = true;
                }
            }
        }
    },

    mounted() {
        if ('Notification' in window && 'PushManager' in window && window.location.protocol === 'https:') {
            this.$beams.getRegistrationState().then((state) => {
                this.beamsRegistrationState = state;
            });

            this.$watch(
                (vm) => [vm.beamsGranted, vm.isLoggedIn],
                () => this.handleChange(),
                { immediate: true, deep: true }
            );
        }
    },

    watch: {
        beamsRegistrationState() {
            if (this.beamsRegistrationState === 'PERMISSION_DENIED' && this.isLoggedIn && this.$cookies.get('webnotifications_declined') === null) {
                this.showSubscribeToNotification = true;
            } else if (
                this.beamsRegistrationState === 'PERMISSION_GRANTED_NOT_REGISTERED_WITH_BEAMS' &&
                this.isLoggedIn &&
                this.$cookies.get('webnotifications_declined') === null
            ) {
                this.showSubscribeToNotification = true;
            } else if (this.beamsRegistrationState === 'PERMISSION_PROMPT_REQUIRED' && this.isLoggedIn && this.$cookies.get('webnotifications_declined') === null) {
                this.showSubscribeToNotification = true;
            } else if (this.beamsRegistrationState === 'PERMISSION_GRANTED_REGISTERED_WITH_BEAMS') {
                this.beamsGranted = true;
                this.showSubscribeToNotification = false;
            }
        }
    },

    computed: {
        ...mapGetters('user', {
            isLoggedIn: 'isLoggedIn',
            user: 'get'
        })
    }
};
</script>
